<ng-template #level let-items let-depth="depth">
  <ul class="node-list" [class.root-list]="depth === 0">
    @for (node of items; track node.id) {
      <li>
        <div class="node-row">
          @if (node.children.length) {
            <button mat-icon-button (click)="toggle(node.id)" [attr.aria-expanded]="isExpanded(node.id)">
              <mat-icon>{{ isExpanded(node.id) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
          } @else {
            <span class="toggle-spacer"></span>
          }
          <div class="node-text">
            <div class="node-title" [class.caps]="depth === 0">{{ node.name }}</div>
            @if (node.description) {
              <div class="node-sub text-faint">{{ node.description }}</div>
            }
          </div>
          <div class="node-actions">
            <button mat-icon-button class="btn-primary" (click)="addNode(node.id)" [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.EDITOR.ADD_CHILD' | translate">
              <mat-icon>add</mat-icon>
            </button>
            <button mat-icon-button class="btn-primary" (click)="editNode(node.id)" [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.EDITOR.EDIT_NODE' | translate">
              <mat-icon>edit</mat-icon>
            </button>
            @if (node.children.length > 0) {
              <span [matTooltip]="'WORKCLASSIFICATION.TEMPLATES.EDITOR.DELETE_CHILDREN_FIRST' | translate">
                <button mat-icon-button class="btn-warn" disabled [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.EDITOR.DELETE_CHILDREN_FIRST' | translate">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            } @else {
              <button mat-icon-button class="btn-warn" (click)="deleteNode(node.id)" [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.EDITOR.DELETE_NODE' | translate">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
        </div>
        @if (node.children.length && isExpanded(node.id)) {
          <ng-container *ngTemplateOutlet="level; context: { $implicit: node.children, depth: depth + 1 }"></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>

<mat-card class="app-main-container">
  <mat-card-header class="custom-card-header">
    <mat-card-title class="card-title">
      <mat-icon class="title-icon">account_tree</mat-icon>
      {{ template()?.name }}
      @if (template()?.isDefault) {
        <span class="status-indicator active title-chip">{{ 'WORKCLASSIFICATION.TEMPLATES.DEFAULT_BADGE' | translate }}</span>
      }
      @if (template() && !template()!.isActive) {
        <span class="status-indicator inactive title-chip">{{ 'WORKCLASSIFICATION.TEMPLATES.INACTIVE_BADGE' | translate }}</span>
      }
    </mat-card-title>
    <div class="responsive-actions header-actions">
      <button mat-stroked-button class="btn-secondary" [routerLink]="['/worktime', 'classification', 'templates']">
        <mat-icon>arrow_back</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.BACK' | translate }}
      </button>
      <button mat-stroked-button class="btn-secondary" (click)="editInfo()" [disabled]="!template()">
        <mat-icon>edit</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.MENU_EDIT' | translate }}
      </button>
      <button mat-flat-button class="btn-primary" (click)="addNode(null)" [disabled]="!template()">
        <mat-icon>add</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.ADD_NODE' | translate }}
      </button>
    </div>
  </mat-card-header>

  <mat-card-content class="app-container">
    @if (template(); as t) {
      @if (t.description) {
        <p>{{ t.description }}</p>
      }
      <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.META' | translate: { count: nodes().length } }}</p>
      <p class="info-note">
        <mat-icon class="info-icon">info</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.NOT_PROPAGATED' | translate }}
      </p>
    }

    @if (loading()) {
      <div class="table-loading"><mat-spinner diameter="32"></mat-spinner></div>
    } @else if (tree().length === 0) {
      <div class="no-data">
        <mat-icon>account_tree</mat-icon>
        <p>{{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.EMPTY_TREE' | translate }}</p>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="level; context: { $implicit: tree(), depth: 0 }"></ng-container>
    }
  </mat-card-content>
</mat-card>
